import { Circle } from "@mui/icons-material";
import { Box, CircularProgress, Typography } from "@mui/material";
import { apiClient } from "api";
import { TourContext } from "contexts/TourContext";
import moment from "moment";
import { ProductsModal } from "pages/Login/ProductsModal";
import React, { useContext, useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "router/types";
import { AppState } from "store/types";
import I18nKey from "translations/I18nKey";

const Subscription = () => {
  const intl = useIntl();
  const { subscription } = useSelector((state: AppState) => state.auth);

  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { openProductsModal, setOpenProductsModal } = useContext(TourContext);

  const handleCheckout = () => {
    setOpenProductsModal(true);
  };
  const handleCloseProductsModal = () => {
    setOpenProductsModal(false);
  };

  const startDate = moment(new Date());
  //moment(subscription.trial_start);
  const endDate = moment(subscription.trial_end);
  const diff = endDate.diff(startDate, "days");

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : subscription?.status === "past_due" ? (
        <Box
          sx={{
            background: "linear-gradient(90deg, #B71C1C 0%, #EF5350 100%)",

            borderRadius: "4px",
            padding: "8px 12px",
            cursor: "pointer",
            minWidth: "150px",
          }}
          onClick={handleCheckout}
        >
          <Typography sx={{ color: "white" }}>Subscription is due</Typography>
        </Box>
      ) : subscription?.status === "error" ? (
        <Box
          sx={{
            background: "linear-gradient(90deg, #B71C1C 0%, #EF5350 100%)",

            borderRadius: "4px",
            padding: "8px 12px",
            cursor: "pointer",
            minWidth: "150px",
          }}
          onClick={handleCheckout}
        >
          <Typography sx={{ color: "white" }}>
            Subscription is Expired
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            background:
              diff <= 5
                ? "linear-gradient(90deg, #B71C1C 0%, #EF5350 100%)"
                : "linear-gradient(90deg, #FF6C37 0%, #FFB077 100%)",
            borderRadius: "4px",
            padding: "8px 12px",
            cursor: "pointer",
          }}
          onClick={handleCheckout}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <Typography
              sx={{ color: diff <= 5 ? "white" : "rgba(0, 43, 73, 1)" }}
            >
              {intl.formatMessage(
                {
                  id: I18nKey.SUBSCRIBE_MSG_DISPLAY,
                },
                { diffDay: diff + 1 }
              )}
            </Typography>
          )}
        </Box>
      )}
      <ProductsModal openProductsModal={openProductsModal} />
    </>
  );
};

export default Subscription;
